function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ComponentBase } from "./Shared/ComponentBase";
import { Configuration } from './Shared/Configuration';
import { I18N } from './Shared/I18n';
export var MppUserLabel = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppUserLabel, _ComponentBase);

  var _super = _createSuper(MppUserLabel);

  function MppUserLabel() {
    var _this;

    _classCallCheck(this, MppUserLabel);

    _this = _super.call(this);
    var config = new Configuration();
    _this._getLocalCountryCode = config.GetLocalCountryCode;
    _this._appRoot = config.GetAppRoot();
    return _this;
  }

  _createClass(MppUserLabel, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback() {
      this.loadAttributes();
      this.renderLabel();
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this._$labelName = this.getAttribute("name");
      var bareAttr = this.getAttribute("bare");
      this._$isBare = !!bareAttr && (bareAttr == "1" || bareAttr.toLocaleLowerCase() == "true");
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppUserLabel.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this2._root.innerHTML = "Unable to connect. Please check Permitted URLs.";
                  } else {
                    _this2._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                this.i18n = _context.sent;
                this.loadAttributes();
                this.renderLabel();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      if (this._$isBare) {
        this._baseRoot.innerHTML = this.i18n[this._$labelName];
      } else {
        var labelClass = "mppw-" + this._$labelName.replace(/[^\w\-\.]/g, "");

        this._baseRoot.innerHTML = "<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />") + "<span id=\"mppw-user-label\" class=\"mppw-component-container mppw-user-label ".concat(labelClass, "\">").concat(this.i18n[this._$labelName], "</span>");
      }

      this._locale = localStorage.userLocale || "en";
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "User Defined Labels",
        tag: "mpp-user-label",
        configurationItems: [{
          name: "Label Name",
          attribute: "name",
          description: "Label Name defined in Application Labels",
          required: true,
          type: "foreignkey",
          fkTable: "dp_application_labels(mpp-user-label)",
          fkFilter: "API_Client_ID_Table.Client_ID='TM.Widgets' AND Label_Name LIKE 'mpp-user-label%'",
          fkSingleName: "Application Label"
        }, {
          name: "Bare Text",
          attribute: "bare",
          description: "Determines whether to include CSS selectors or just a bare text object",
          required: false,
          type: "bool"
        }]
      };
    }
  }]);

  return MppUserLabel;
}(ComponentBase);

_defineProperty(MppUserLabel, "observedAttributes", ["name", "bare"]);

MppUserLabel.registerComponent(MppUserLabel.WidgetDetails.tag, MppUserLabel);